import { useTranslation } from "react-i18next";

function UnexpectedError() {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col h-screen items-center justify-center gap-2">
      <div className="text-2xl">{t("unexpected-error.title")}</div>
      <div>{t("unexpected-error.message")}</div>
    </div>
  );
}

export default UnexpectedError;
